"use strict";
/**
 * @module Services.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var permission_1 = require("./../../features/security/permission");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var list_path_permissions_result_1 = require("./../../services/security/list-path-permissions-result");
var security_1 = require("../../../features/security");
/**
 * Serialiser for {@link ListPathPermissionsResult}
 */
var ListPathPermissionsResultSerialiserClass = /** @class */ (function (_super) {
    __extends(ListPathPermissionsResultSerialiserClass, _super);
    function ListPathPermissionsResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListPathPermissionsResultSerialiserClass.prototype.read = function (bis) {
        return new list_path_permissions_result_1.ListPathPermissionsResult(Codec.readCollection(bis, function () {
            var k = permission_1.PathPermissionCode[bis.read()];
            return security_1.PathPermission[k];
        }));
    };
    return ListPathPermissionsResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ListPathPermissionsResultSerialiserClass = ListPathPermissionsResultSerialiserClass;
/**
 * The {@link ListPathPermissionsResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ListPathPermissionsResultSerialiser = new ListPathPermissionsResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/list-path-permissions-result-serialiser.js
// module id = 1387
// module chunks = 1